// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5ed80418","453":"ea8fd745"}[chunkId] + ".chunk.js";
};